module.exports = __webpack_public_path__ + "static/media/logoFooter.e0800df9.png";